"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectHowToPayDeferred = void 0;
const SelectHowToPay_1 = require("../inputs/SelectHowToPay");
const DeferredAction_1 = require("./DeferredAction");
class SelectHowToPayDeferred {
    constructor(player, amount, options = {}) {
        this.player = player;
        this.amount = amount;
        this.options = options;
        this.priority = DeferredAction_1.Priority.DEFAULT;
    }
    execute() {
        this.player.totalSpend += this.amount;
        if ((!this.player.canUseHeatAsMegaCredits || this.player.availableHeat === 0) &&
            (!this.options.canUseSteel || this.player.steel === 0) &&
            (!this.options.canUsePlants || this.player.plants === 0) &&
            (!this.options.canUseTitanium || this.player.titanium === 0) &&
            !this.options.canUseAsteroids && !this.options.canUseGraphene && !this.options.canUseSpireScience) {
            this.player.megaCredits -= this.amount;
            if (this.options.afterPay !== undefined) {
                this.options.afterPay();
            }
            return undefined;
        }
        return new SelectHowToPay_1.SelectHowToPay(this.options.title || 'Select how to spend ' + this.amount + ' M€', this.options.canUseSteel || false, this.options.canUseTitanium || false, this.player.canUseHeatAsMegaCredits && this.player.availableHeat > 0, this.options.canUseGraphene || false, this.options.canUseAsteroids || false, this.options.canUsePlants || false, this.options.canUseSpireScience || false, this.amount, (howToPay) => {
            this.player.plants -= howToPay.plants;
            this.player.steel -= howToPay.steel;
            this.player.titanium -= howToPay.titanium;
            this.player.megaCredits -= howToPay.megaCredits;
            this.player.spendGraphene(howToPay.graphene);
            this.player.spendSpireScience(howToPay.spireScience);
            this.player.spendAsteroids(howToPay.asteroids);
            this.player.game.defer(new DeferredAction_1.DeferredAction(this.player, () => this.player.spendHeat(howToPay.heat)));
            if (this.options.afterPay !== undefined) {
                this.options.afterPay();
            }
            return undefined;
        });
    }
}
exports.SelectHowToPayDeferred = SelectHowToPayDeferred;
(function (SelectHowToPayDeferred) {
    ;
})(SelectHowToPayDeferred = exports.SelectHowToPayDeferred || (exports.SelectHowToPayDeferred = {}));
//# sourceMappingURL=SelectHowToPayDeferred.js.map